import React from "react";
import Box from "@mui/system/Box";
import { useNavigate } from "react-router-dom";
import logoReverse from "../assests/images/CC-Logo-reverse.svg";

const Header = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ width: 1 }}>
      <img src={logoReverse} alt="College Contact" onClick={()=>{ navigate('/') }} />
    </Box>
  );
};

export default Header;
